'use client'

import { type FC } from 'react'
import { useStats } from 'react-instantsearch'
import { FormattedMessage } from 'react-intl'

import { ProductSearchResultHeaderInfoIconButton } from './ProductSearchResultHeaderInfoIconButton'

export const ProductSearchResultHeader: FC = () => {
  const { nbHits } = useStats()

  return (
    <div className="flex flex-col">
      <h1 className="text-2xl font-medium tablet:text-4xl">
        <FormattedMessage id="general.label.SearchResult" />
      </h1>
      <div className="text-s font-bold text-dark-primary-strong">
        <FormattedMessage
          id="searchResults.label.totalResultsNumber"
          values={{ total: nbHits }}
        />
        <ProductSearchResultHeaderInfoIconButton />
      </div>
    </div>
  )
}
